import { useIntl } from "react-intl";

export const useFilterButtonText = () => {
  const { formatMessage } = useIntl();

  const filterButtonText = formatMessage({ id: 'routesHistory' });

  return filterButtonText;
};